export default __webpack_public_path__ + "static/mce-81d438a6919c1d8a2de3c648a3a13f64.jpg";